// import DocumentDetail from "@/pages/docs/detail";
import { apiDocumentSearch } from "@/services/docs";
import { MessageOutlined, SendOutlined } from "@ant-design/icons";
import { ProCard, ProForm, ProFormInstance } from "@ant-design/pro-components";
import { Button, FloatButton, Popover } from "antd";
import { useRef, useState } from "react";

const ChatBot: React.FC = () => {

    const [data, setData] = useState<any[]>([
        'Xin chào 👋, hãy nhập từ khóa, tôi sẽ giúp bạn tìm kiếm văn bản!'
    ]);
    const [loading, setLoading] = useState<boolean>(false);
    const formRef = useRef<ProFormInstance>();
    const [open, setOpen] = useState<boolean>(false);
    const [documentId, setDocumentId] = useState<string>();
    const onShow = (id: string) => {
        setDocumentId(id);
        setOpen(true);
    }

    const onFinish = async (values: any) => {
        setLoading(true);
        let newData = [...data];
        if (values.message) {
            newData.push(values.message);
            const response = await apiDocumentSearch({
                searchTerm: values.message
            });
            if (response.data.length === 0) {
                newData.push(`Không tìm thấy văn bản, hãy thử một từ khóa khác 👀`)
            } else {
                const resultMessage = (
                    <ul>
                        Một số văn bản được tìm thấy:
                        {response.data.map((x: any) => (
                            <li className="mr-1 font-medium cursor-pointer hover:text-blue-600" key={x.id} onClick={() => onShow(x.id)}>&bull; {x.number}/{x.kyHieuVanBan}</li>
                        ))}
                    </ul>
                )
                newData.push(resultMessage);
            }
            setLoading(false);
        }
        setData(newData);
    }

    const Content = () => (
        <ProCard title="Trợ lý ảo" size="small" headerBordered>
            <ProForm submitter={false} onFinish={onFinish} formRef={formRef}>
                <div className="border mb-1">
                    <div className="h-72 w-72 overflow-auto p-2">
                        {
                            data.map((value: any, index: number) => (
                                <div key={index} className="mb-1">
                                    <div className={`${index % 2 === 0 ? 'bg-slate-100' : 'bg-blue-100'} w-64 rounded-md`}>
                                        <div className="p-2 rounded">{value}</div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="text-center mb-2">
                        <span className="text-slate-400 cursor-pointer hover:text-slate-500" onClick={() => setData([])}>đoạn chat mới</span>
                    </div>
                </div>
                <div className="flex gap-1">
                    <div className="flex-1 h-full">
                        <ProForm.Item name="message" className="mb-0 h-full">
                            <input type="text" className="w-full px-2 py-2 h-full bg-slate-100 outline-none rounded-l" />
                        </ProForm.Item>
                    </div>
                    <Button htmlType="submit" type="primary" loading={loading} icon={<SendOutlined />} />
                </div>
            </ProForm>
        </ProCard>
    )

    return (
        <>
            <Popover content={<Content />} trigger="click" overlayInnerStyle={{
                padding: 0
            }}>
                <FloatButton tooltip="Trợ lý ảo" icon={<MessageOutlined />} />
            </Popover>
            {/* <DocumentDetail open={open} onOpenChange={setOpen} id={documentId} /> */}
        </>
    )
}

export default ChatBot;